// Shape a birthday into MM/DD/YYYY as the customer types, the format the
// portal login reads. "05151985" becomes "05/15/1985" and "5/15/1985" becomes
// "05/15/1985". A slash is only added once the next digit arrives, so
// Backspace is never stuck on one. Anything with other characters (a pasted
// "1985-05-15" or "May 15, 1985", both of which the login accepts) is left
// alone.
const SEGMENT_LENGTHS = [2, 2, 4];
// A month can only start with 0 or 1 and a day with 0 to 3, so any higher
// first digit is a single-digit month or day.
const SEGMENT_FIRST_DIGIT_MAX = ["1", "3"];

export const formatBirthdayInput = (value: string): string => {
  if (!/^[\d/]*$/.test(value)) {
    return value;
  }

  const segments: string[] = [""];
  for (const char of value) {
    let index = segments.length - 1;
    if (char === "/") {
      if (segments[index] && index < SEGMENT_LENGTHS.length - 1) {
        if (segments[index].length === 1) {
          segments[index] = `0${segments[index]}`;
        }
        segments.push("");
      }
      continue;
    }
    if (segments[index].length === SEGMENT_LENGTHS[index]) {
      if (index === SEGMENT_LENGTHS.length - 1) {
        break;
      }
      segments.push("");
      index += 1;
    }
    const firstDigitMax = SEGMENT_FIRST_DIGIT_MAX[index];
    segments[index] +=
      segments[index] === "" && firstDigitMax && char > firstDigitMax
        ? `0${char}`
        : char;
  }
  return segments.join("/");
};

// Whether a birthday is ready to submit. MM/DD/YYYY must be a full, real date:
// the server guesses a year for "05/15" and rolls "02/30" into March, so
// either could check the wrong date. Text the formatter leaves alone (a pasted
// "May 15, 1985") is left for the server to read.
export const isBirthdayComplete = (value: string): boolean => {
  const trimmed = value.trim();
  if (trimmed === "") {
    return false;
  }
  if (!/^[\d/]*$/.test(trimmed)) {
    return true;
  }

  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(trimmed);
  if (!match) {
    return false;
  }
  const [month, day, year] = match.slice(1).map(Number);
  const date = new Date(year, month - 1, day);
  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
};
